<div class="availability"
     [class.availability--open]="isOpen">
  <button type="button"
          (click)="onToggle()"
          class="btn btn-orange availability__toggle availability__toggle--employee">
    <i class="fa fa-chevron-{{isOpen ? 'down' : 'up'}} me-3"></i>
    <span class="fw-bold">Dostupnost radnika</span>
  </button>
  <div [class.container]="singleOrder">
    <div [class.row]="singleOrder">
      <div [class.col-10]="singleOrder" [class.offset-2]="singleOrder">
        <div class="row g-0">
          <div class="order-item">
            <div class="order-item__title">Stalno zaposleni</div>
          </div>

          <div class="col" *ngFor="let day of availability; trackBy: trackByFn">
            <div class="day">
              <div class="day__shifts">
                <div class="day__shift" *ngFor="let shift of day.shifts; trackBy: trackByFn">
                  <div class="fw-bold font-14"
                  >{{ shift.permanentAvailableTime | digitFormat }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row g-0 mt-2">
          <div class="order-item">
            <div class="order-item__title">Dodatni resursi</div>
          </div>

          <div class="col" *ngFor="let day of availability; trackBy: trackByFn">
            <div class="day">
              <div class="day__shifts">
                <div class="day__shift" *ngFor="let shift of day.shifts; trackBy: trackByFn">
                  <div class="fw-bold font-14"
                  >{{ shift.seasonalAvailableTime | digitFormat }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr>

        <div class="row g-0 mt-2">
          <div class="order-item">
            <div class="order-item__title">Ukupno minuta</div>
          </div>

          <div class="col" *ngFor="let day of availability; trackBy: trackByFn">
            <div class="day">
              <div class="day__shifts">
                <div class="day__shift" *ngFor="let shift of day.shifts; trackBy: trackByFn">
                  <div class="fw-bold font-14"
                       [class.text-red]="shift.timePlannedEmployee > shift.totalAvailableTime">
                    {{ shift.totalAvailableTime | digitFormat }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row g-0 mt-2">
          <div class="order-item">
            <div class="order-item__title">Planirano minuta</div>
          </div>

          <div class="col" *ngFor="let day of availability; trackBy: trackByFn">
            <div class="day">
              <div class="day__shifts">
                <div class="day__shift" *ngFor="let shift of day.shifts; trackBy: trackByFn">
                  <div class="fw-bold font-14"
                       [class.text-red]="shift.timePlannedEmployee > shift.totalAvailableTime">
                    {{ shift.timePlannedEmployee | digitFormat }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row g-0 mt-2">
          <div class="order-item">
            <div class="order-item__title">Preostalo minuta</div>
          </div>

          <div class="col" *ngFor="let day of availability; trackBy: trackByFn">
            <div class="day">
              <div class="day__shifts">
                <div class="day__shift" *ngFor="let shift of day.shifts; trackBy: trackByFn">
                  <div class="fw-bold font-14"
                       [class.text-green]="shift.timePlannedEmployee < shift.totalAvailableTime"
                       [class.text-red]="shift.timePlannedEmployee > shift.totalAvailableTime">
                    {{ (shift.totalAvailableTime?.toFixed() - shift.timePlannedEmployee?.toFixed()) | digitFormat }}</div>
                </div>
              </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
